import { PageLoading } from '@/components';
import React, { Suspense } from 'react';
import { ArcoProvider } from './ArcoProvider';
import { AuthProvider } from './AuthProvider';
import { ErrorBoundaryProvider } from './ErrorBoundaryProvider';
import { ReactQueryProvider } from './ReactQueryProvider';
import { ThemeProvider } from './ThemeProvider';
import { ReactRouterProvider } from './ReactRouterProvider';

export const AppProvider = () => {
  return (
    <Suspense fallback={<PageLoading />}>
      <ErrorBoundaryProvider>
        <ThemeProvider>
          <ArcoProvider>
            <ReactQueryProvider>
              <AuthProvider>
                <ReactRouterProvider />
              </AuthProvider>
            </ReactQueryProvider>
          </ArcoProvider>
        </ThemeProvider>
      </ErrorBoundaryProvider>
    </Suspense>
  );
};
